<template>
  <v-dialog v-model="dialog" width="500px">
    <v-card class="rounded">
      <v-form @submit.prevent="submit" lazy-validation ref="form">
        <v-card-title class="lighten-2">{{
          $t("modal.enterTheAmountInKilograms")
        }}</v-card-title>
        <v-card-text class="my-4">
          <v-row class="justify-center">
            <v-col md="7">
              <v-text-field
                v-model="input.weight"
                class="rounded text-right"
                filled
                :rules="[rules.required, rules.number]"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            color="light"
            text
            style="height: 50px; width: 50px; font-size: 50px"
            @click="dialog = false"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            color="light"
            text
            type="submit"
            style="height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      input: {},
      item: null,
      isAdmin: false,
      rules: {
        required: v => !!v || "",
        number: v => v > 0 || ""
      }
    };
  },
  methods: {
    open(item, isAdmin) {
      this.dialog = true;
      this.item = item;
      this.isAdmin = isAdmin;
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.item.pricePerWeight) {
          this.item.pricePerWeight = this.item.price;
        }

        this.item.weight = parseFloat(this.input.weight);

        const totalPrice =
          this.item.pricePerWeight * parseFloat(this.input.weight);
        this.item.price = totalPrice;

        if (this.isAdmin) {
          this.item.cart_type = "admin";
        }

        this.item.order_translations = {
          en: this.translateToOneLang("name", this.item, "en"),
          es: this.translateToOneLang("name", this.item, "es"),
          de: this.translateToOneLang("name", this.item, "de"),
          fr: this.translateToOneLang("name", this.item, "fr"),
          it: this.translateToOneLang("name", this.item, "it")
        };

        if (!this.item.isMenuGroupProduct) {
          this.$store.commit("addToCart", { item: this.item, update: true });
          this.$store.dispatch("addStripeProductToCart", this.item);
          this.$forceUpdate(); // Force update to fetch cart data (for displaying the new quantity)
        } else {
          this.$store.commit("saveMenuGroupData", {
            item: this.item,
            update: true
          });
          this.$emit("setMenuGroupItem", this.item);
        }
        this.dialog = false;
        this.$refs.form.reset();
      }
    }
  }
};
</script>

<style></style>
